import { Injectable, InjectionToken } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { SharedService } from '~/services/sharedService';

export const PORTAL_DATA = new InjectionToken<{}>('PortalData');

@Injectable({ providedIn: 'root' })
export class LayoutManagerService {

  constructor(private _sharedService: SharedService) {

  }

  overlayChange: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  favoritesChange: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  okCloseClicked: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  removePopup: Subject<boolean> = new Subject<boolean>();
  clickChange: Subject<any> = new Subject<any>();
  formChanged: Subject<string> = new Subject<string>();
  pendingNote: string = '';

  applyOverly() {
    this.overlayChange.next(true);
  }

  removeOverlay() {
    this.overlayChange.next(false);
  }

  detachPopup(okCloseClicked: boolean) {
    this.removePopup.next(true);
    if (okCloseClicked) {
      this.okCloseClicked.next(true);
      this._sharedService.okCloseClicked.emit(true);
    }
    else {
      this.okCloseClicked.next(false);
      this._sharedService.okCloseClicked.emit(false);
    }
  }

  setPageClick(event: any) {
    this.clickChange.next(event);
  }

  setFavorites(favoritePages: any) {
    this.favoritesChange.next(favoritePages);
  }

  setFromChanged(formName: string) {
    this.formChanged.next(formName);
  }


}
